import find from 'lodash/find';
import get from 'lodash/get';
import reduce from 'lodash/reduce';

import { RootState } from 'App';
import deepEqualsCreateSelector from 'utils/deepEqualsCreateSelector';

export const isLoggedInSelector = ({ messages }: RootState) => messages.isLoggedInChat;

export const isConnectedSelector = ({ messages }: RootState) => messages.isConnected;

export const unreadListSelector = ({ messages }: RootState) => messages.unreadList;

export const chatsSelector = ({ messages }: RootState) => messages.chats;

export const activeChatSelector = ({ messages }: RootState) => messages.activeChat;

export const chatsListSelector = deepEqualsCreateSelector(
  [chatsSelector], ({ list }) => list,
);

export const isCanUpdateChatsListSelector = deepEqualsCreateSelector(
  [chatsSelector], ({ isCanUpdate }) => isCanUpdate,
);

export const isNeedUpdateChatsListSelector = deepEqualsCreateSelector(
  [chatsSelector], ({ isNeedUpdate }) => isNeedUpdate,
);

export const activeChatIdSelector = deepEqualsCreateSelector(
  [activeChatSelector], ({ id }) => id,
);

export const isTypingActiveChatSelector = deepEqualsCreateSelector(
  [activeChatSelector], ({ isTyping }) => isTyping,
);

export const activeChatMessagesSelector = deepEqualsCreateSelector(
  [activeChatSelector], ({ messages }) => messages,
);

export const isCanUpdateChatMessagesSelector = deepEqualsCreateSelector(
  [activeChatSelector], ({ isCanUpdate }) => isCanUpdate,
);

interface IActiveChat {
  name: string,
  status: 'online' | 'offline'
  conversationId: string,
  uid: string,
}

export const chatByActiveChatIdSelector = deepEqualsCreateSelector(
  [chatsSelector, activeChatIdSelector],
  ({ list }, id) => {
    const { name, status, conversationId, uid }: IActiveChat = get(
      find(list, ['conversationWith.uid', id]), 'conversationWith')
    || { name: '', status: 'offline', conversationId: '', uid: '' };

    return { name, status, conversationId, uid };
  },
);

export const unreadCountMessagesSelector = deepEqualsCreateSelector(
  [unreadListSelector],
  (unreadList) => reduce(unreadList, (acc, count) => acc + count, 0),
);

export const unreadCountChatMessagesSelector = deepEqualsCreateSelector(
  [unreadListSelector, (_, { id }) => id],
  (unreadList, id) => unreadList[id] || 0,
);
